module.exports = __webpack_public_path__ + "img/linkedin.0791db3c.png";